module.exports = __webpack_public_path__ + "img/IM.11130526.png";